const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const REQUEST_TIMEOUT = 30000; // 30 seconds

const api = {
  getToken() {
    return localStorage.getItem('token');
  },
  setToken(t) {
    t ? localStorage.setItem('token', t) : localStorage.removeItem('token');
  },
  async request(endpoint, options = {}) {
    const token = this.getToken();
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT);

    try {
      const res = await fetch(`${API_URL}${endpoint}`, {
        ...options,
        headers,
        signal: controller.signal,
      });

      if (res.status === 401) {
        this.setToken(null);
        window.location.href = '/login';
        throw new Error('Session expired. Please log in again.');
      }

      if (!res.ok) {
        const e = await res.json().catch(() => ({ error: 'Request failed' }));
        throw new Error(e.error);
      }

      return res.json();
    } catch (err) {
      if (err.name === 'AbortError') {
        throw new Error('Request timed out. Please try again.');
      }
      throw err;
    } finally {
      clearTimeout(timeoutId);
    }
  },
  async blob(endpoint) {
    const token = this.getToken();
    const res = await fetch(`${API_URL}${endpoint}`, {
      headers: { ...(token && { Authorization: `Bearer ${token}` }) },
    });
    if (res.status === 401) { this.setToken(null); window.location.href = '/login'; }
    if (!res.ok) throw new Error('Download failed');
    return res.blob();
  },
  get: (e) => api.request(e),
  post: (e, d) => api.request(e, { method: 'POST', body: JSON.stringify(d) }),
  put: (e, d) => api.request(e, { method: 'PUT', body: JSON.stringify(d) }),
  delete: (e) => api.request(e, { method: 'DELETE' }),
};

export default api;
